import { render } from "./syntheseIntervenant.vue?vue&type=template&id=8648e2dc"
import script from "./syntheseIntervenant.vue?vue&type=script&lang=ts"
export * from "./syntheseIntervenant.vue?vue&type=script&lang=ts"
script.render = render

export default script